import {selectOrderDeliveryMethod} from 'app/features/orders/redux/order/orderEditSlice'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import OrderDeliveryMethod from 'app/features/orders/componentsv1/view/deliveryMethod/OrderDeliveryMethod'
import {useState} from 'react'
import DeliveryMethodAction from '../deliveryMethodAction/DeliveryMethodAction'
import {hideLoader} from 'app/redux/loaderSlice'

export const DeliveryMethodWrapper = () => {
  const dispatch = useDispatch()
  const orderDeliveryMethod = useSelector<RootState, string | any>(selectOrderDeliveryMethod)

  const [showDialog, setShowDialog] = useState(false)

  const handleOpenDialog = () => {
    setShowDialog(true)
  }

  const handleCloseDialog = () => {
    setShowDialog(false)
    dispatch(hideLoader())
  }

  return (
    <>
      <OrderDeliveryMethod orderDeliveryMethod={orderDeliveryMethod} onClick={handleOpenDialog} />
      {showDialog && <DeliveryMethodAction onClose={handleCloseDialog} />}
    </>
  )
}

export default DeliveryMethodWrapper
